import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  modal: {
    '& .MuiDialog-paper': {
      width: '658px',
      maxWidth: '100%',
      borderRadius: '12px',
      paddingBottom: '12px',
      '@media (max-width: 768px)': {
        width: '90%',
        margin: '16px',
      },
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5) !important',
    },
    '& .MuiDialogTitle-root': {
      padding: '0 !important',
      minHeight: '0 !important',
      position: 'absolute',
      right: '16px',
      top: '16px',
      zIndex: 1,
      borderBottom: 'none !important',
    },
  },
  modalContent: {
    padding: '0 !important',
    borderTop: 'none !important',
    '&:first-of-type': {
      paddingTop: '0 !important',
    },
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '32px 32px 24px 32px',
    '@media (max-width: 768px)': {
      padding: '24px 20px 16px 20px',
    },
  },
  iconContainer: {
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      marginBottom: '16px',
      '& svg': {
        width: '70px',
        height: '70px',
      },
    },
  },
  title: {
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT1,
    textAlign: 'center',
    margin: '0 0 12px 0',
    '@media (max-width: 768px)': {
      fontSize: '20px',
      lineHeight: '26px',
      marginBottom: '8px',
    },
  },
  description: {
    fontSize: '16px',
    lineHeight: '26px',
    fontWeight: 500,
    color: STYLE.COLOR.TEXT1,
    textAlign: 'center',
    margin: '0 0 16px 0',
    '@media (max-width: 768px)': {
      fontSize: '14px',
      lineHeight: '22px',
      marginBottom: '12px',
    },
  },
  descriptionDesktop: {
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  descriptionMobile: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'inline',
    },
  },
  contactList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '@media (max-width: 768px)': {
      gap: '6px',
    },
  },
  contactItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '4px 0',
    backgroundColor: 'transparent',
    borderRadius: '8px',
    '@media (max-width: 768px)': {
      gap: '6px',
      padding: '3px 0',
    },
  },
  contactIcon: {
    width: '18px',
    height: '18px',
    flexShrink: 0,
    marginTop: '4px',
    '& path': {
      fill: STYLE.COLOR.ACCENT_PRIMARY,
    },
    '@media (max-width: 768px)': {
      width: '16px',
      height: '16px',
      marginTop: '3px',
    },
  },
  contactDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
  phoneContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
  contactLink: {
    fontSize: '16px',
    lineHeight: '26px',
    fontWeight: 600,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    textDecoration: 'underline',
    wordBreak: 'break-word',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
    '@media (max-width: 768px)': {
      fontSize: '14px',
      lineHeight: '22px',
    },
  },
  contactSubtext: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
    '@media (max-width: 768px)': {
      fontSize: '13px',
      lineHeight: '18px',
    },
  },
}));
